module.exports = {
	"_format": "hh-sol-dbg-1",
	"buildInfo": "../../../build-info/6d847f64-e6d9-4f30-94db-71a9a7838a6f.json"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/DiscoLPFactory.sol/IUniswapV2Factory.dbg.json
// module id = 1544
// module chunks = 0